module.exports = __webpack_public_path__ + "img/year.07b38106.svg";